import axios from 'axios'
import { API_RESPONSE_CODES, CONFIG } from './helperConstants'
import { ERRORS } from './messages'
import { clearSessionStorage, getToken } from './helper'
import { NOTIFICTION_MESSAGES } from 'components/ui/utils/messages'

const { BASE_URL } = CONFIG

const config = {
    headers: {
        Authorization: '',
    },
}

export const logout = () => {
    clearSessionStorage()
}

const handleErrorResponse = async (err) => {
    const {
        UNAUTHORISED,
        FORBIDDEN,
        NOT_FOUND,
        BAD_REQUEST,
        INTERNAL_SERVER_ERROR,
        PAYLOAD_ERROR,
    } = API_RESPONSE_CODES
    const {
        status = '',
        data = {
            errorCode: INTERNAL_SERVER_ERROR,
            errorMessage: NOTIFICTION_MESSAGES.SOMETHING_WENT_WRONG,
        },
    } = err?.response
    if (
        [
            UNAUTHORISED,
            FORBIDDEN,
            NOT_FOUND,
            BAD_REQUEST,
            INTERNAL_SERVER_ERROR,
            PAYLOAD_ERROR,
        ].includes(status)
    ) {
        if (status === UNAUTHORISED) {
            logout()
        }
    }
    if (err) {
        if (err?.response?.data?.errorMessage) {
            return {
                err,
                errorCode: err.response.data.code || INTERNAL_SERVER_ERROR,
                isSuccessful: false,
                error: err.response.data,
                errorMessage:
                    err?.response?.data?.errorMessage || ERRORS.NETWORK_ERROR,
            }
        }
        if (err.message === ERRORS.NETWORK_ERROR) {
            logout()
        }
        return {
            err,
            errorCode: INTERNAL_SERVER_ERROR,
            isSuccessful: false,
            error: data,
            errorMessage: ERRORS.NETWORK_ERROR,
        }
    }
    return err
}

const handleSuccessResponse = (res) => {
    const { SUCCESS } = API_RESPONSE_CODES
    if (res.status === SUCCESS) {
        return res.data
    }
    return res
}

export const getData = (url, isTokenReq = true) => {
    const accessToken = getToken()
    if (!isTokenReq || accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
        return axios
            .get(`${BASE_URL}${url}`, config)
            .then((res) => handleSuccessResponse(res))
            .catch((err) => handleErrorResponse(err))
    }
    return ''
}

export const postData = (url, body, loginFlag = false) => {
    if (!loginFlag) {
        const accessToken = getToken()
        config.headers.Authorization = `Bearer ${accessToken}`
    } else {
        delete config.headers.Authorization
    }
    config.headers['Content-Type'] = body?.isMultiPartData
        ? 'multipart/form-data'
        : 'application/json'
    return axios
        .post(`${BASE_URL}${url}`, body, config)
        .then((res) => handleSuccessResponse(res))
        .catch((err) => handleErrorResponse(err))
}

export const putData = (url, body, isTokenReq = true) => {
    const accessToken = getToken()
    if (!isTokenReq || accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
        config.headers['Content-Type'] = body?.isMultiPartData
            ? 'multipart/form-data'
            : 'application/json'
        return axios
            .put(`${BASE_URL}${url}`, body, config)
            .then((res) => handleSuccessResponse(res))
            .catch((err) => handleErrorResponse(err))
    }
    return ''
}

export const deleteData = (url, body = null, isTokenReq = true) => {
    const accessToken = getToken()
    if (!isTokenReq || accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
        return axios
            .delete(`${BASE_URL}${url}`, { ...config, data: body })
            .then((res) => handleSuccessResponse(res))
            .catch((err) => handleErrorResponse(err))
    }
    return ''
}
